import { Box } from '@chakra-ui/react';
import { gridConfig } from '@time-line/components/common';
import type { ReactNode } from 'react';
import { SnapItem } from 'react-snaplist-carousel';

import { DiscountBadge } from '../DiscountBadge';
import type { DiscountBadgeData } from '../types';

const { gridBorderRadius } = gridConfig;

interface ProductGalleryMobileItemWrapperProps {
  hasOneItem: boolean;
  children: ReactNode;
  aspectRatio?: number;
  discountBadge?: DiscountBadgeData | null;
}

export const ProductGalleryMobileItemWrapper = ({
  aspectRatio = 1,
  hasOneItem,
  children,
  discountBadge,
}: ProductGalleryMobileItemWrapperProps) => {
  const wrapperProps = hasOneItem
    ? { width: '100%' }
    : { as: SnapItem, flexShrink: 0, snapAlign: 'center', width: '87%' };

  return (
    <Box {...wrapperProps}>
      <Box
        borderRadius={gridBorderRadius}
        overflow="hidden"
        aspectRatio={aspectRatio}
        width="100%"
        display="grid"
        position="relative"
        sx={{
          '> *': {
            gridRow: 1,
            gridColumn: 1,
          },
        }}
      >
        {discountBadge && (
          <DiscountBadge
            price={discountBadge.price}
            compareAtPrice={discountBadge.compareAtPrice}
          />
        )}
        {children}
      </Box>
    </Box>
  );
};
